export default "__VITE_ASSET__ZDzJj_WcUdZlGrfR5dtceQ__";